{
  "name": "tradigames-backoffice",
  "version": "1.0.0",
  "description": "Tradigames back office",
  "author": {
    "name": "Vyde",
    "url": "https://vyde-entertainment.com/"
  },
  "homepage": "https://vyde-entertainment.com/",
  "config": {
    "theme": "default",
    "coreui_library_short_version": "5.6",
    "coreui_library_docs_url": "https://coreui.io/angular/docs/"
  },
  "scripts": {
    "ng": "ng",
    "start": "ng serve -o",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.2.5",
    "@angular/cdk": "^21.2.3",
    "@angular/common": "^21.2.5",
    "@angular/compiler": "^21.2.5",
    "@angular/core": "^21.2.5",
    "@angular/forms": "^21.2.5",
    "@angular/language-service": "^21.2.5",
    "@angular/platform-browser": "^21.2.5",
    "@angular/platform-browser-dynamic": "^21.2.5",
    "@angular/router": "^21.2.5",
    "@coreui/angular": "~5.6.21",
    "@coreui/angular-chartjs": "~5.6.21",
    "@coreui/chartjs": "~4.1.0",
    "@coreui/coreui": "~5.4.3",
    "@coreui/icons": "^3.0.1",
    "@coreui/icons-angular": "~5.6.21",
    "@coreui/utils": "^2.0.2",
    "ngx-bootstrap": "^21.0.1",
    "chart.js": "^4.5.1",
    "file-saver": "^2.0.5",
    "json2typescript": "^1.6.1",
    "lodash-es": "^4.17.21",
    "ngx-scrollbar": "^19.1.4",
    "font-awesome": "^4.7.0",
    "rxjs": "~7.8.2",
    "tslib": "^2.8.1",
    "zone.js": "~0.15.1",
    "uuid": "^11.1.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^21.2.3",
    "@angular/cli": "^21.2.3",
    "@angular/compiler-cli": "^21.2.5",
    "@angular/localize": "^21.2.5",
    "@types/jasmine": "^5.1.4",
    "@types/lodash-es": "^4.17.12",
    "@types/node": "^20.17.1",
    "jasmine-core": "^5.4.0",
    "karma": "^6.4.4",
    "karma-chrome-launcher": "^3.2.0",
    "karma-coverage": "^2.2.1",
    "karma-jasmine": "^5.1.0",
    "karma-jasmine-html-reporter": "^2.1.0",
    "typescript": "~5.9.3"
  },
  "engines": {
    "node": "^18.19.0 || ^20.9.0 || ^22.0.0",
    "npm": ">= 9"
  }
}
